import { initializeApp } from "firebase/app";

// Deine Firebase-Konfiguration
const firebaseConfig = {
    apiKey: "AIzaSyCtESjT3tPXLPY5GDmXPea5-eDqZ5-PlaA",
    authDomain: "storageio-d3dac.firebaseapp.com",
    databaseURL: "https://storageio-d3dac-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "storageio-d3dac",
    storageBucket: "storageio-d3dac.appspot.com",
    messagingSenderId: "966469654886",
    appId: "1:966469654886:web:d48d45632fa745f68910a7",
    measurementId: "G-Y5EZVCKYM1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Exportiere nur das, was du tatsächlich verwendest
export { app };